import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  copyRightContainer: {
    display: "flex",
    justifyContent: "space-between",
    "@media (max-width: 1200px)": {
      flexDirection: "column",
      alignItems: "flex-start"
    }
  },
  copyRight: {
    fontSize: 14,
    lineHeight: 1.5,
    fontWeight: 700,
    textTransform: "uppercase",
    color: "#FFFFFF",
    "& a": {
      color: "inherit"
    },
    "&:hover": {
      textDecoration: "underline"
    },
    "@media (max-width: 1200px)": {
      width: "100%"
    }
  },
  copyRightLinks: {
    display: "flex",
    alignItems: "center",
    "@media (max-width: 1200px)": {
      marginTop: 8,
    },
    "@media (max-width: 920px)": {
      marginTop: 8,
      flexDirection: "column",
      alignItems: "flex-start"
    }
  },
  copyRightLink: {
    fontSize: 14,
    lineHeight: 1.5,
    fontWeight: 700,
    textTransform: "uppercase",
    color: "#FFFFFF",
    "& + $copyRightLink": {
      marginLeft: 51,
      "@media (max-width: 600px)": {
        marginLeft: 0,
        marginTop: 8
      }
    },
    "@media (max-width: 920px)": {
      "& ~ $copyRightLink": {
        marginTop: 8
      }
    },
    "@media (max-width: 1200px)": {
      fontWeight: 600
    }
  },
  copyRightSeparator: {
    width: 1,
    height: 16,
    backgroundColor: "#FFFFFF",
    marginLeft: 8,
    marginRight: 8,
    "@media (max-width: 920px)": {
      display: "none"
    }
  }
});
